<template>
  <div id="app" class="app-root">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

